import React, { useEffect, useRef, useState } from "react"
import { useLocation } from '@reach/router'
import Flink from '~/components/shared/flink'
import { useTheme }  from '~/contexts/ThemeContext'
import { notBlank, jnstyls} from '~/utils/helpers'

import { Overlay, Captions } from './wraps'
import HomeImg from './home-img'

import * as styles from "~/styles/home/full-bleed.module.scss"

const FullBleed = ({ block, index, preview=false }) => {
  const location = useLocation()
  const { pageLoad, isMobile } = useTheme()

  if (block.id === 1539) block.mob_fullb = true
  const { captions } = block
  const [isPreview, setIsPreview] = useState(false)
  const blockRef = useRef(null)

  let has_capts = captions.length && captions.map( x => x.contents && x.contents.length > 0 && x.contents.find(y => notBlank(y.copy) || y.links?.length > 0))
  has_capts = has_capts ? has_capts.filter(x => !!x).length > 0 : false
  const use_link = notBlank(block.url) && !block.vid_controls

  useEffect(() => {
    if (location.pathname.includes('/preview/')) setIsPreview(true)

    if (!blockRef.current) return

    const el = blockRef.current

    setTimeout(() => {
      if (!el) return
      el.style.minHeight = null
      const style = window.getComputedStyle(el)
      const is_visible = style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
      let head_el = false

      if (is_visible) {
        head_el = document.querySelector('#header')
        if (head_el) {
          head_el.setAttribute('full','true')
          if (block.mob_fullb) head_el.setAttribute('mfull','true')
        }
      }
      if (isMobile && !block.mob_fullb) {
        if (el) el.removeAttribute('full-block')
        if (document.querySelector('#header')) document.querySelector('#header').removeAttribute('full')
      }
    }, 100)

    setTimeout(() => {
      if (!el) return
      el.style.minHeight = null
    }, 400)

    return () => {
      if (((isMobile && block.mob_fullb) || !block.multi) && document.querySelector('#header')) {
        document.querySelector('#header').removeAttribute('full')
        document.querySelector('#header').removeAttribute('mfull')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!(pageLoad && blockRef.current)) return
    blockRef.current.style.minHeight = null
  }, [pageLoad])

  return (
    <div 
      className={jnstyls([styles.fb_wrap, `${block.first ? styles.first : ''}`])} 
      mok-block={index} 
      full-block={''}
      mobfull={block.mob_fullb ? 'true' : 'false'}
      g={block.gender}
      ref={blockRef}
      style={{marginTop: preview ? '115px' : '', minHeight: '70vh'}}
      mid={block.id}
      om={block.only_mobi ? '' : undefined} 
      style={{minHeight: '60vh'}}
    >
      

      {use_link ? (
        <Flink href={block.url}>
          <ImgBlock block={block} index={index} isPreview={isPreview} />
        </Flink>
      ) : (
        <ImgBlock block={block} index={index} isPreview={isPreview} />
      )}

      {!!has_capts && (
        <Captions 
          block={block} 
          item={captions} 
          is_text={false} 
          index={index} 
          pstyles={styles}
        />
      )}
    </div>
  )
}


const ImgBlock = ({ block, index, isPreview }) => {
  const { images, overlays } = block

  let has_overs = overlays.length && overlays.map( x => x.contents && x.contents.length > 0 && x.contents.find(y => notBlank(y.copy) || y.links?.length > 0))
  has_overs = has_overs ? has_overs.filter(x => !!x).length > 0 : false

  return (
    <div className={styles.content}>
      <HomeImg 
        item={images[0]} 
        show_mobile={true} 
        index={index} 
        pstyles={styles}
        block={block}
      />
      {!!has_overs && (
        <div className={jnstyls([styles.over_cont,`overlay${block.id}`])}>
          {overlays.map((overlay, overlayIndex) =>
            <Overlay 
              key={`overlay${overlayIndex}`} 
              block={block} 
              item={overlay} 
              index={index} 
              pstyles={styles}
            />
          )}
        </div>
      )}
    </div>
  )
}



export default FullBleed



